import React, { Component } from "react";
import { Modal, Row, Col, Radio, Input, message, Button } from "antd";
import Axios from "axios";
import axios from "../../../../services/axios";
import { errorMessage } from "../../../Utils";

let cancelToken;

class ModalNoPolisi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmLoading: false,
      licensePlate: "",
      listLicensePlate: [],
      isCheck: false,
      isAvailable: false,
      selectedPlate: null,
      isNotFound: false,
      dataPlate: { id: "", status: "" },
    };
  }

  selectChange = (value) => {
    this.setState({
      appraiserId: value,
    });
  };

  checkNopol = async () => {
    let { licensePlate } = this.state;
    this.setState({
      listLicensePlate: [],
      confirmLoading: true,
      isCheck: true,
    });
    if (cancelToken) {
      cancelToken.cancel("Operation canceled due to new request");
    }
    cancelToken = Axios.CancelToken.source();
    licensePlate = licensePlate.trim();

    await axios
      .post(`car-sales/license-plate-check`, {
        licensePlate,
      })
      .then((result) => {
        this.setState({
          licensePlate,
          listLicensePlate: result.data.carSales,
          isAvailable: result.data.isAvailable,
          confirmLoading: false,
          isNotFound: false,
        });
      })
      .catch((err) => {
        if (!Axios.isCancel(err)) {
          errorMessage(err.response || err);
          this.setState({ confirmLoading: false, isNotFound: true });
        }
      });
  };

  render() {
    const {
      confirmLoading,
      licensePlate,
      isCheck,
      isAvailable,
      isNotFound,
      listLicensePlate,
      dataPlate,
      selectedPlate,
    } = this.state;
    const { toggleShowModal, showModal } = this.props;
    return (
      <Modal
        title="Nomor Polisi"
        visible={showModal}
        confirmLoading={confirmLoading}
        okText={"Cek Nopol"}
        onOk={() => this.checkNopol()}
        onCancel={() => toggleShowModal(false)}
        footer={null}
        width={650}>
        <div>
          <div>No Polisi</div>
          <div
            style={{
              paddingTop: 10,
              paddingBottom: 10,
              paddingLeft: 0,
              paddingRight: 0,
            }}>
            <Col>
              <Input
                value={licensePlate}
                onChange={(event) =>
                  this.setState({
                    licensePlate: event.target.value.replace(/\s+/g, " "),
                  })
                }
              />
            </Col>
          </div>
          <Row type="flex" justify="end">
            <Col>
              <Button
                htmlType="button"
                type="primary"
                loading={confirmLoading}
                onClick={() => this.checkNopol()}>
                Cek Nopol
              </Button>
            </Col>
          </Row>

          {isCheck && !confirmLoading ? (
            <div style={{ margin: "10px 0" }}>
              <div style={{ margin: "5px 0", fontWeight: "bold" }}>
                Nomor Polisi{" "}
                {isAvailable && listLicensePlate.length > 0 ? "" : "Tidak"}{" "}
                Tersedia
              </div>
              <div style={{ margin: "5px 0", fontSize: 12 }}>
                Nomor Polisi yang anda masukkan{" "}
                {isAvailable && listLicensePlate.length > 0 ? "" : "tidak"}{" "}
                tersedia pada sistem
                {isAvailable && listLicensePlate.length > 0
                  ? ", silakan pilih unit yang ingin anda masukkan nomor polisinya"
                  : isNotFound
                  ? "."
                  : ", anda bisa menambahkan nomor polisi tersebut kepada daftar baru pada sistem"}{" "}
              </div>
              {isAvailable && listLicensePlate.length > 0 ? (
                <Radio.Group
                  value={selectedPlate}
                  onChange={(e) =>
                    this.setState({
                      selectedPlate: !selectedPlate
                        ? Number(e.target.value)
                        : selectedPlate === Number(e.target.value)
                        ? null
                        : Number(e.target.value),
                    })
                  }>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      margin: "5px 0",
                    }}>
                    {listLicensePlate.map((item, index) => {
                      return (
                        <Radio
                          key={index}
                          style={{ margin: "5px 0" }}
                          value={item.id}
                          onClick={(e) => {
                            this.setState({
                              selectedPlate: !selectedPlate
                                ? Number(e.target.value)
                                : selectedPlate === Number(e.target.value)
                                ? null
                                : Number(e.target.value),
                              dataPlate: {
                                id: e.target.value,
                                status: item.status,
                              },
                            });
                          }}>
                          {item.carName} ({item.code})
                        </Radio>
                      );
                    })}
                  </div>
                </Radio.Group>
              ) : null}
              {!isNotFound && !confirmLoading ? (
                <Row type="flex" justify="end">
                  <Col>
                    <Button
                      htmlType="button"
                      type="primary"
                      onClick={() => {
                        selectedPlate
                          ? this.props.history.push({
                              pathname: `/home/e-approval/selling-system/detail/${dataPlate.id}`,
                              state: {
                                id: dataPlate.id,
                                status: dataPlate.status.toLowerCase(),
                              },
                            })
                          : toggleShowModal(false, licensePlate);
                      }}>
                      Tambah Nopol{" "}
                      {isAvailable && listLicensePlate.length > 0 ? "" : "Baru"}
                    </Button>
                  </Col>
                </Row>
              ) : null}
            </div>
          ) : null}
        </div>
      </Modal>
    );
  }
}

export default ModalNoPolisi;



// WEBPACK FOOTER //
// src/components/Dashboard/EApproval/Modal/ModalNoPolisi.js